import React from "react";
import Dialog from "rc-dialog";
import moment from "moment";
import axios from "axios";
import classNames from "classnames";
import { mutate } from "swr";
import TabledEventStudent from "./TabledEventStudent";
import TabledElearningResults from "./TabledElearningResults";
import ReactTooltip from "react-tooltip";
import { EndTermToggle } from "../../../components/EndTermToggle";

export default class EventStudent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            studentUUID: false,
            studentDetails: false,
            studentEventDetails: false,
            loading: false,
            showSaving: false,
            saving: false,
            showExemptionDialog: false,
            showExemptionErrorDialog: false,
            showExemptionError: null,
            exemptionEndterm: false,
            exemptionCourse: false,
            studentCancelled: false,
            studentAvailableCertifications: [],
            studentHasResults: "",
            studentExemptionDetails: null,
            ignoreProgressFromOtherCourses: true
            // studentCompetenceprofileDetails: false
        };
    }

    getStudentData() {
        const student = this.props.course.students.find((s) => s.uuid === this.props.studentUUID);

        this.setState(
            {
                loading: true,
                showSaving: false,
                studentHasResults: !!student?.has_results
            },
            () => {
                axios
                    .all([
                        axios.get(`/v1/users/${this.props.studentUUID}/`),
                        // axios.get(`/v1/users/${this.props.studentUUID}/competenceprofiles/${this.props.course.competence_profile}/`),
                        axios.get(`/v1/users/${this.props.studentUUID}/courses/${this.props.course.uuid}/`),
                        axios.get(`/v1/courses/${this.props.course.uuid}/students/${this.props.studentUUID}/`)
                    ])
                    .then(
                        axios.spread((user, course, student) => {
                            // fixme: below var definitions are rather strange... StudentDetails containing userData instead of studentDetails?
                            this.setState(
                                {
                                    studentUUID: this.props.studentUUID,
                                    studentDetails: user.data,
                                    // studentCompetenceprofileDetails: cp.data,
                                    course: course.data,
                                    studentEventDetails: student.data.events,
                                    studentExemptionDetails: student.data.exemptions,
                                    studentOptions: student.data.student_options,
                                    studentCancelled: student.data.cancelled,
                                    studentAvailableCertifications: student.data.available_certifications,
                                    loading: false
                                },
                                () => this.calculateProgressStatus()
                            );
                        })
                    )
                    .catch((error) => {
                        console.log(error);
                    });
            }
        );
    }

    toggleInsurance = (event) => {
        const { value } = event.target;
        if (value === this.props.isInsured) {
            return;
        }
        this.toggleOption("insured", value);
    };

    toggleEmployerSpecific = (event) => {
        const { value } = event.target;
        if (value === this.props.isEmployerSpecific) {
            return;
        }
        this.toggleOption("employer_specific", value);
    };

    /**
     * Toggles the value of a course student option.
     * @param {"insured"|"employer_specific"} option The option to change.
     * @param {boolean} value
     */
    toggleOption = (option, value) => {
        this.setState({
            showSaving: true,
            saving: true
        });
        const course_detail_url = `/v1/courses/${this.props.course.uuid}/`;
        axios
            .patch(course_detail_url, {
                student_options: [
                    {
                        user: this.props.studentUUID,
                        [option]: value
                    }
                ]
            })
            .then((response) => {
                // trigger the handler which is passed that could handle changes of other sources
                this.props.parentGetEvents();

                // mutate below is very specific (only updates course_detail_url cache) and did not trigger apropriate updaets
                return mutate(course_detail_url, response.data, false);
            })
            .then(() => {
                this.setState({
                    saving: false
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    getStudentDataOnly = () => {
        axios
            .all([
                axios.get(`/v1/users/${this.props.studentUUID}/`),
                axios.get(`/v1/courses/${this.props.course.uuid}/students/${this.props.studentUUID}/`),
                axios.get(`/v1/users/${this.props.studentUUID}/courses/${this.props.course.uuid}/`)
            ])
            .then(
                axios.spread((user, student, course) => {
                    this.setState({
                        studentDetails: user.data,
                        studentEventDetails: student.data.events,
                        course: course.data
                    });
                })
            )
            .catch((error) => {
                console.log(error);
            });
    };

    updateStudentAttendance = (studentUUID, eventUUID, eventRoleUUID, willAttend) => {
        this.setState({
            showSaving: true,
            saving: true
        });

        axios
            .patch(`/v1/courses/${this.props.course.uuid}/events/${eventUUID}/eventroles/${eventRoleUUID}/students/${studentUUID}/`, {
                will_attend: willAttend
            })
            .then((response) => {
                this.props.parentGetEvents();
                this.getStudentDataOnly();

                this.setState({
                    showSaving: true,
                    saving: false
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    addExemption = () => {
        let studentID = this.state.studentDetails && this.state.studentDetails.uuid;
        let endtermID = this.state.exemptionEndterm || false;
        let courseID = this.state.exemptionCourse || false;
        // let competenceprofileID = this.state.studentCompetenceprofileDetails && this.state.studentCompetenceprofileDetails.uuid;

        if (studentID && endtermID && courseID) {
            this.setState({
                showSaving: true,
                saving: true
            });

            axios
                .post(`/v1/users/${studentID}/exemptions/`, {
                    competence_profile: this.props.course.competence_profile,
                    end_term: endtermID,
                    course: courseID
                })
                .then((response) => {
                    this.props.parentGetEvents();
                    this.getStudentDataOnly();

                    this.setState({
                        showSaving: true,
                        saving: false,
                        showExemptionDialog: false
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    removeExemption = (studentID, endtermID, exemptionID) => {
        this.setState({
            showSaving: true,
            saving: true
        });

        axios
            .delete(`/v1/users/${studentID}/exemptions/${exemptionID}/`)
            .then((response) => {
                this.props.parentGetEvents();
                this.getStudentDataOnly();

                this.setState({
                    showSaving: false,
                    saving: false
                });
            })
            .catch((error) => {
                // Error, show this
                this.setState({
                    showSaving: false,
                    saving: false,
                    showExemptionError: error.response.data.detail,
                    showExemptionErrorDialog: true
                });
            });
    };

    updateCheck = () => {
        if (!this.state.loading && this.props.studentUUID !== false && this.state.studentUUID !== this.props.studentUUID) {
            this.getStudentData();
        }
    };

    componentDidMount() {
        this.updateCheck();
    }

    calculateProgressStatus = () => {
        let hasNotStarted = false;
        let isInProgress = false;
        let isAchieved = false;
        let isAchievedInOtherCourse = false;
        let isNotAchieved = false;
        let studentProgress;

        hasNotStarted =
            !this.state.studentHasResults &&
            !this.state.course?.competence_profile?.end_terms?.some((endTerm) => {
                return (
                    !this.state.ignoreProgressFromOtherCourses &&
                    this.state.studentAvailableCertifications.some((certification) => {
                        return certification.end_terms.some((et) => {
                            return (
                                et.uuid === endTerm.uuid &&
                                et.latest_progress?.status_slug !== "not-achieved" &&
                                Math.floor((new Date() - new Date(et.latest_progress?.date)) / (1000 * 60 * 60 * 24)) <= 93
                            );
                        });
                    })
                );
            });

        isInProgress =
            this.state.course?.competence_profile?.end_terms?.some((term) => term.latest_progress !== null) ||
            this.state.course?.competence_profile?.end_terms?.some((endTerm) => {
                return (
                    !this.state.ignoreProgressFromOtherCourses &&
                    this.state.studentAvailableCertifications?.some((certification) => {
                        return certification.end_terms?.some((et) => {
                            return (
                                et.latest_progress?.status_slug !== "not-achieved" &&
                                et.uuid === endTerm.uuid &&
                                Math.floor((new Date() - new Date(et.latest_progress?.date)) / (1000 * 60 * 60 * 24)) <= 93
                            );
                        });
                    })
                );
            });

        isAchieved = this.state.course?.competence_profile?.end_terms?.every(
            (term) => term.latest_progress?.is_achieved === true || this.state.studentExemptionDetails?.some((exemption) => exemption.end_term === term.uuid)
        );

        isAchievedInOtherCourse = this.state.course?.competence_profile?.end_terms?.every((endTerm) => {
            return (
                !this.state.ignoreProgressFromOtherCourses &&
                this.state.studentAvailableCertifications?.some((certification) => {
                    return certification.end_terms?.some((et) => {
                        return (
                            et.uuid === endTerm.uuid &&
                            et.latest_progress?.status_slug === "achieved" &&
                            Math.floor((new Date() - new Date(et.latest_progress?.date)) / (1000 * 60 * 60 * 24)) <= 93
                        );
                    });
                })
            );
        });

        isNotAchieved = this.state.course?.competence_profile?.end_terms.some((term) => term.latest_progress !== null && term.latest_progress.is_achieved === false);

        if (hasNotStarted) {
            studentProgress = <span className="courses-tag courses-tag-md courses-tag-not-started">Niet begonnen</span>;
        }
        if (isInProgress) {
            studentProgress = <span className="courses-tag courses-tag-md courses-tag-in-progress">Bezig</span>;
        }
        if (isNotAchieved) {
            studentProgress = <span className="courses-tag courses-tag-md courses-tag-not-achieved">Niet behaald</span>;
        }
        if (isAchievedInOtherCourse) {
            studentProgress = <span className="courses-tag courses-tag-md courses-tag-achieved-in-another-course">Behaald in andere cursus</span>;
        }
        if (isAchieved) {
            studentProgress = <span className="courses-tag courses-tag-md courses-tag-achieved">Behaald</span>;
        }

        return studentProgress;
    };

    getCertificationAvailability = () => {
        const fullyAchieved = this.state.course?.competence_profile?.end_terms?.every(
            (term) => term.latest_progress?.is_achieved === true || this.state.studentExemptionDetails?.some((exemption) => exemption.end_term === term.uuid)
        );

        const partiallyAchieved =
            !fullyAchieved &&
            this.state.course?.competence_profile?.end_terms?.some(
                (term) => term.latest_progress?.is_achieved === true || this.state.studentExemptionDetails?.some((exemption) => exemption.end_term === term.uuid)
            );

        let status;

        if (fullyAchieved)
            status = (
                <span style={{ width: "auto", padding: "4px 10px" }} className="courses-tag courses-tag-md courses-tag-achieved">
                    Complete certificering
                </span>
            );
        else if (!fullyAchieved && partiallyAchieved)
            status = (
                <span style={{ width: "auto", padding: "4px 10px" }} className="courses-tag courses-tag-md courses-tag-in-progress">
                    Gedeeltelijke certificering
                </span>
            );

        return status ? (
            <>
                <strong>Beschikbare certificeringen</strong>
                <br />
                {status}
            </>
        ) : null;
    };

    render = () => {
        let details = <p>Cursist ophalen...</p>;

        // Check if we have completed our learning if applicable
        let elearningStatus = false;
        let currentCourseStudent = this.props.course.students.find((student) => student.uuid === this.props.studentUUID);

        if (currentCourseStudent && currentCourseStudent.elearning_status !== null) {
            let elearningStudentStatus = currentCourseStudent.elearning_status;
            if (elearningStudentStatus == "new") {
                elearningStatus = (
                    <span style={{ width: "auto", padding: "4px 10px" }} className="courses-tag courses-tag-md  courses-tag-not-started">
                        Nog niet begonnen
                    </span>
                );
            }
            if (elearningStudentStatus == "active") {
                elearningStatus = (
                    <span style={{ width: "auto", padding: "4px 10px" }} className="courses-tag courses-tag-md  courses-tag-in-progress">
                        Nog bezig
                    </span>
                );
            }
            if (elearningStudentStatus == "achieved") {
                elearningStatus = (
                    <span style={{ width: "auto", padding: "4px 10px" }} className="courses-tag courses-tag-md  courses-tag-achieved">
                        Behaald
                    </span>
                );
            }
            if (elearningStudentStatus == "not-achieved") {
                elearningStatus = (
                    <span style={{ width: "auto", padding: "4px 10px" }} className="courses-tag courses-tag-md  courses-tag-not-achieved">
                        Niet behaald
                    </span>
                );
            }
        }

        if (!this.state.loading) {
            const course = this.state.course;

            const studentProgress = this.calculateProgressStatus();

            let insuranceStatus = <span className="courses-tag courses-tag-md courses-tag-full courses-tag-active">Niet beschikbaar</span>;
            if (this.props.course.insurance_available) {
                // Check if this course has already finished events, in that case it is not allowed to change this status
                let insuranceAllowed = !this.props.events.find((evt) => evt.type !== "elearning" && evt.is_editable === false);
                if (insuranceAllowed) {
                    insuranceStatus = (
                        <select
                            className="form-control form-online form-control-sm"
                            disabled={this.state?.studentCancelled}
                            value={this.state?.studentOptions?.insured || false}
                            onChange={this.toggleInsurance}
                        >
                            <option value={true}>Ja</option>
                            <option value={false}>Nee</option>
                        </select>
                    );
                } else {
                    insuranceStatus = (
                        <span className="courses-tag courses-tag-md courses-tag-full courses-tag-active">{this.props.isInsured ? "Verzekerd" : "Niet verzekerd"}</span>
                    );
                }
            }

            let eventRows = [];
            if (this.state.studentEventDetails) {
                this.props.events.forEach((event) => {
                    // state of this user in this course:
                    let studentDetails = this.state.studentEventDetails; // data from: /v1/courses/<uuid>/students/<uuid>/
                    // the event in this course:
                    let eventDetails = studentDetails.find((evt) => evt.uuid === event.uuid);

                    if (!eventDetails) {
                        // happens when student are deleted on *some* of the events but not all.
                        return;
                    }

                    // attending student in this event:
                    let currentStudent = eventDetails.students.find((student) => student.uuid === this.props.studentUUID);

                    let willAttend = false;
                    let hasAttended = false;
                    if (currentStudent) {
                        willAttend = currentStudent && currentStudent.will_attend === true;
                        hasAttended = currentStudent && currentStudent.attended === true;
                    }

                    let attendButton = (
                        <i
                            className="fa fa-toggle-off color-blue"
                            onClick={() => this.updateStudentAttendance(this.state.studentDetails.uuid, event.uuid, event.event_roles[0].uuid, true)}
                        />
                    );
                    if (willAttend) {
                        attendButton = (
                            <i
                                className="fa fa-toggle-on color-blue"
                                onClick={() => this.updateStudentAttendance(this.state.studentDetails.uuid, event.uuid, event.event_roles[0].uuid, false)}
                            />
                        );
                    }
                    if (event.type === "elearning") {
                        // Presence is not given for elearning measurementmoments
                        // todo: we DO have a will_attend and attended property on currentStudent!
                        attendButton = "Nog niet begonnen";
                        if (currentStudent && currentStudent.elearning_status == "active") {
                            attendButton = "Nog bezig";
                        }
                        if (currentStudent && currentStudent.elearning_status == "achieved") {
                            attendButton = "Behaald";
                        }
                        if (currentStudent && currentStudent.elearning_status == "not-achieved") {
                            attendButton = "Nog bezig";
                        }
                        if (currentStudent && currentStudent.is_exempt === true) {
                            attendButton = "N.v.t.";
                        }
                    } else if (!event.is_editable) {
                        // Check if the student was present
                        attendButton = <i className="fa fa-times" />;

                        if (hasAttended) {
                            attendButton = <i className="fa fa-check" />;
                        }
                    }

                    eventRows.push(
                        <tr key={`eventrow-${event.uuid}`} className={classNames({ inactive: !willAttend })}>
                            <td>{event.start_datetime ? moment(event.start_datetime).format("DD-MM-YYYY") : "N.N.B."}</td>
                            <td>
                                {event.name}
                                {!event.is_editable && event.type !== "elearning" && (
                                    <span className="lighter">
                                        <br />
                                        Dit toetsmoment heeft al resultaten, de aanwezigheid kan niet langer worden aangepast.
                                    </span>
                                )}
                            </td>
                            <td width="100">{attendButton}</td>
                        </tr>
                    );
                });
            }

            let endtermRows = [];
            let endtermResultRows = [];

            course?.competence_profile?.end_terms?.forEach((endTerm, i) => {
                endtermRows.push(
                    <EndTermToggle
                        isCancelled={this.state.studentCancelled}
                        type={"tr"}
                        key={endTerm.uuid}
                        userUUID={this.state.studentDetails.uuid}
                        courseUUID={this.props.course?.uuid}
                        competenceProfileUUID={this.props.course.competence_profile}
                        endTerm={endTerm}
                        exemption={this.state.studentExemptionDetails?.find((e) => e.end_term === endTerm?.uuid)}
                        disabled={() => {
                            const exemption = this.state.studentExemptionDetails?.find((e) => e.end_term === endTerm?.uuid);
                            return exemption ? exemption.has_results || !exemption.can_be_deleted : false;
                        }}
                        onSuccess={() => {
                            // when we toggle, both endTerms and the overview should be mutated as this info relies on it
                            this.props.parentGetEvents();
                            this.getStudentDataOnly();

                            this.setState({
                                showSaving: false,
                                saving: false
                            });
                        }}
                    />
                );

                endtermResultRows.push(<EndTermStatusRow endTerm={endTerm} courseClosed={!["new", "active"].includes(course.state)} key={i} />);
            });

            let endtermExemptions = false;
            if (endtermRows.length > 0) {
                endtermExemptions = (
                    <div>
                        <h2>Vrijstellingen per eindterm</h2>
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Eindterm</th>
                                    <th width="180">Vrijgesteld</th>
                                </tr>
                            </thead>
                            <tbody>{endtermRows}</tbody>
                        </table>
                    </div>
                );
            }

            let endtermResults = false;
            if (endtermResultRows.length > 0) {
                endtermResults = (
                    <div>
                        <h2>Afgeronde eindtermen</h2>
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Eindterm</th>
                                    <th width="180">Status</th>
                                </tr>
                            </thead>
                            <tbody>{endtermResultRows}</tbody>
                        </table>
                    </div>
                );
            }

            details = (
                <div>
                    <div className="row mt-3">
                        <div className="col-4">
                            <strong>NIBHV-nummer</strong>
                            <br />
                            {this.state.studentDetails.nibhv_number}
                        </div>
                        <div className="col-5 break-word">
                            <strong>E-mailadres</strong>
                            <br />
                            <a className="link" href={`mailto:${this.state.studentDetails.email}`}>
                                {this.state.studentDetails.email}
                            </a>
                        </div>
                        <div className="col-3">
                            <strong>Geboortedatum</strong>
                            <br />
                            {moment(this.state.studentDetails.date_of_birth).format("DD-MM-YYYY")}
                        </div>
                    </div>
                    <div className="row mt-3 mb-5">
                        <div className="col-4">
                            <strong>Verzekerd voor deze cursus</strong>
                            <br />
                            {insuranceStatus}
                            {
                                this.props.course.employer_specific_available ? (
                                    <div className="mt-3">
                                        <strong>Bedrijfsspecifiek</strong>
                                        <select
                                            disabled={this.state?.studentCancelled}
                                            className="form-control form-online form-control-sm"
                                            value={this.state?.studentOptions?.employer_specific || false}
                                            onChange={this.toggleEmployerSpecific}
                                        >
                                            <option value={true}>Ja</option>
                                            <option value={false}>Nee</option>
                                        </select>
                                    </div>
                                ) : null // dunno what to put here when it's not available.
                            }
                        </div>
                        <div className="col-5">
                            <strong>Competentieprofiel status</strong>
                            <i
                                style={{ marginLeft: "10px", fontSize: "27px", lineHeight: "27px", position: "relative", top: "5px", cursor: "pointer" }}
                                onClick={() =>
                                    this.setState(
                                        (prev) => ({ ignoreProgressFromOtherCourses: !prev.ignoreProgressFromOtherCourses }),
                                        () => this.calculateProgressStatus()
                                    )
                                }
                                className={classNames("fa color-blue", this.state.ignoreProgressFromOtherCourses ? "fa-toggle-off" : "fa-toggle-on")}
                                data-tip
                                data-for="tip-ignore-progress"
                            />
                            <ReactTooltip id="tip-ignore-progress" effect="solid">
                                {this.state.ignoreProgressFromOtherCourses ? "Toon voortgang van andere cursussen." : "Negeer voortgang vanuit andere cursussen."}
                            </ReactTooltip>

                            <br />
                            {studentProgress}

                            <div className="mt-3">{this.getCertificationAvailability()}</div>
                        </div>
                        <div className="col-3">
                            <strong>E-learning status</strong>
                            <br />
                            {elearningStatus || "Niet van toepassing"}
                        </div>
                    </div>

                    {elearningStatus && (
                        <>
                            <h2>E-learning blokken</h2>
                            <TabledElearningResults course={course} studentUUID={this.state?.studentUUID} courseUUID={this.props?.course?.uuid} />
                        </>
                    )}

                    <h2>Cursusresultaten</h2>
                    <TabledEventStudent
                        ignoreProgressFromOtherCourses={this.state.ignoreProgressFromOtherCourses}
                        studentUUID={this.state?.studentUUID}
                        courseUUID={this.props?.course?.uuid}
                    />
                    {endtermExemptions}
                </div>
            );
        }

        return (
            <div>
                <Dialog
                    title={this.state.loading ? "Cursist ophalen..." : this.state.studentDetails.full_name}
                    onClose={() => this.props.closeStudentDialog()}
                    visible={this.props.visible}
                >
                    {details}

                    {this.state.showSaving ? (
                        <div className="notification-saving">
                            {this.state.saving ? (
                                <span>
                                    Bezig met opslaan <i className="fa fa-spin fa-spinner"></i>
                                </span>
                            ) : (
                                <span>
                                    Opgeslagen! <i className="fa fa-check"></i>
                                </span>
                            )}
                        </div>
                    ) : (
                        false
                    )}
                </Dialog>

                <Dialog
                    title="Vrijstelling geven"
                    onClose={() => this.setState({ showExemptionDialog: false })}
                    visible={this.state.showExemptionDialog}
                    animation="fade"
                    footer={[
                        <button type="button" className="btn btn-light" key="no" onClick={() => this.setSate({ showExemptionDialog: false })}>
                            Nee
                        </button>,
                        <button type="button" className="btn btn-primary" key="yes" onClick={() => this.addExemption()}>
                            Ja
                        </button>
                    ]}
                >
                    <p>
                        Weet je zeker dat je {this.state.studentDetails && this.state.studentDetails.full_name} een vrijstelling wilt geven voor deze eindterm?
                        <br />
                        Vergeet de cursist niet op afwezig te zetten onder de aanwezigheidsstatus.
                    </p>
                    <p>
                        Wil je de cursist uiteindelijk toch niet certificeren? Zorg er dan voor dat je vóór de afronding van het eerste praktijk toetsmoment de
                        vrijstelling weer annuleert. Er zullen dan geen kosten in rekening worden gebracht.
                    </p>
                </Dialog>

                <Dialog
                    title="Kan vrijstelling niet aanpassen"
                    onClose={() => this.setState({ showExemptionErrorDialog: false })}
                    visible={this.state.showExemptionErrorDialog}
                    animation="fade"
                    footer={[
                        <button type="button" className="btn btn-primary" key="yes" onClick={() => this.setState({ showExemptionErrorDialog: false })}>
                            Sluiten
                        </button>
                    ]}
                >
                    <p>{this.state.showExemptionError}</p>
                </Dialog>
            </div>
        );
    };
}

function EndTermExemptionRow({ endTerm, isExempted, onClick, ...props }) {
    return (
        <tr className={classNames({ inactive: !isExempted })} {...props}>
            <td>{endTerm.name}</td>
            <td width="180">
                {endTerm?.can_be_exempted && <i onClick={onClick} className={classNames("fa color-blue", isExempted ? "fa-toggle-on" : "fa-toggle-off")} />}
                {!endTerm?.can_be_exempted && (
                    <>
                        <i className="fa fa-info-circle" data-tip data-for={"tip-" + endTerm.uuid} />
                        <ReactTooltip id={"tip-" + endTerm.uuid} effect="solid">
                            Voor deze eindterm is er geen vrijstelling toegestaan
                        </ReactTooltip>
                    </>
                )}
            </td>
        </tr>
    );
}

function EndTermStatusRow({ endTerm, courseClosed, ...props }) {
    let display = "Nog niet behaald";
    let icon = "fa-ellipsis-h";
    if (endTerm.is_exempted) {
        display = "Vrijgesteld";
        icon = "fa-check";
    } else if (endTerm.latest_progress?.is_achieved) {
        display = "Behaald";
        icon = "fa-check";
    } else if (courseClosed) {
        display = "Niet behaald";
        icon = "fa-times";
    }

    return (
        <tr {...props}>
            <td>{endTerm.name}</td>
            <td width="180">
                <i className={classNames("fa", icon)} /> {display}
            </td>
        </tr>
    );
}
